"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceModels = void 0;
const resource_1 = __importDefault(require("./resource"));
exports.ResourceModels = [
    resource_1.default,
];
